import { useUniversityContext } from '@/context';
import { useCallback, useState } from 'react';
import API from '@/services/APIs';
import { useAppStore, useCartStore } from '@/store';
import moment from 'jalali-moment';
import { useTranslation } from 'react-i18next';

export default function useBasketManagement() {

  const [t] = useTranslation(['common']);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const creditValue = useAppStore(state => state.credit);
  const basketItems = useCartStore(state => state.programs);
  const universityURL = useUniversityContext()?.university?.universityURL;

  const submit = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const token = (await API.User.getLoginToken()).payload.loginAsToken;
      console.log('basketItems[0].food', basketItems[0].food);
      const weekStartTimeStamp = moment.from(basketItems[0]?.food?.programDate, 'en').format('YYYY-MM-DD+hh:mm:ss');
      console.log('weekStartTimeStamp', weekStartTimeStamp);
      // const weekStartTimeStamp = format(startOfWeek(basketItems[0].food?.programDate!), "yyyy-MM-dd")

      let encodablePart = 'action=checkout';

      const addGeneralItemToURL = (key: string, value: any) => {
        encodablePart = encodablePart + `&${key}=${value}`;
      };
      const addBasketItemToURL = (index: number, key: string, value: any) => {
        encodablePart = encodablePart + `&userWeekReserves[${index}].${key}=${value}`;
      };

      const baseURL = `${universityURL}/j_security_check?loginAsToken=${token}&redirect=/nurture/user/multi/reserve/reserve.rose?`;
      addGeneralItemToURL('weekStartDateTime', weekStartTimeStamp);
      addGeneralItemToURL('remainCredit', creditValue);
      addGeneralItemToURL('method%3AdoReserve', 'Submit');
      addGeneralItemToURL('selectedSelfDefId', basketItems[0].food?.selfId);
      for (let i = 0; i < basketItems.length; i++) {
        addBasketItemToURL(i, 'selected', 'true');
        addBasketItemToURL(i, 'programId', basketItems[i].food?.programId);
        addBasketItemToURL(i, 'mealTypeId', basketItems[i].food?.mealTypeId);
        addBasketItemToURL(i, 'programDateTime', basketItems[i].food?.programDateTime);
        addBasketItemToURL(i, 'selfId', basketItems[i].food?.selfId);
        addBasketItemToURL(i, 'foodTypeId', basketItems[i].food?.foodTypeId);
        addBasketItemToURL(i, 'selectedCount', basketItems[i].selectedCount);
        addBasketItemToURL(i, 'freeFoodSelected', 'false');
      }
      const URL = baseURL + encodeURIComponent(encodablePart);
      console.log({ URL });

      setLoading(false);
      window.open(URL);
    }
    catch (e) {
      setError(t('common:labels.submit-request'));
      console.log('error: ', e);
    }
  },
  [basketItems, creditValue, universityURL, t]
  );

  return { loading, error, submit };
}
